const announcementReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default announcementReducer;